import React, { useState } from 'react';
import styled from 'styled-components';
import { Row } from './SearchResultItem';
import style from 'styles/styled-components/style';
import useToast from 'hooks/useToast';
import { apis } from 'apis/apis';
import { PlatformCode } from 'type/common';
import CoreTag from 'shared/tag/CoreTag';
import CoreGrayButton from 'shared/button/CoreGrayButton';
import { IExistence } from 'apis/search_apis';
import TableCell from 'components/common/table/cell/TableCell';
import { useNavigate } from 'react-router-dom';

interface IDummyRow {
	platform: PlatformCode;
	keyword: string;
}

const SearchResultDummyItem = ({ platform, keyword }: IDummyRow) => {
	const navigate = useNavigate();
	const toast = useToast();

	const [loading, setLoading] = useState(false);

	const checkExistence = async () => {
		try {
			setLoading(true);

			const params: IExistence = {
				platform_code: platform,
				keyword: keyword,
			};

			const data = await apis.getInfluencerExistence(params);
			setLoading(false);
			if (data.platform_pk === null)
				toast('존재하지 않는 인플루언서 계정입니다.', false, true);
			else if (data.platform_pk !== null) {
				const params = new URLSearchParams(location.search);
				params.append('rm', 'm');
				params.append('pk', data.platform_pk as string);
				params.append('p', platform);
				navigate({ search: params.toString() });
			}
		} catch (err) {
			setLoading(false);
			console.log(err);
		}
	};

	return (
		<DummyRow>
			<TableCell.Profile
				platform_code={platform}
				username={keyword}
				_width={72}
				_margin="0 16px 0 0"
			/>
			<TableCell.Id
				username={keyword}
				full_name={keyword}
				_width={205}
				_margin="0 32px 0 0"
			/>
			<TableCell _width={220} _margin="0 32px 0 0">
				<CoreTag tag_type="text" color_type="gray" value="분석 전" />
			</TableCell>
			<style.Grid _width="100px" _margin=" 0 57px 0 0" flex="end">
				<style.Text typo="span">분석 전</style.Text>
			</style.Grid>
			<style.Grid _width="106px" flex_option="1 0" flex="end">
				<CoreGrayButton
					size="small"
					style_type="filled"
					text="분석 요청"
					is_loading={loading}
					_onClick={checkExistence}
				/>
			</style.Grid>
		</DummyRow>
	);
};

const DummyRow = styled(Row)`
	background-color: ${({ theme }) => theme.colors.gray.gray10};
	&:hover {
		background-color: ${({ theme }) => theme.colors.gray.gray10};
	}

	cursor: default;
`;

export default SearchResultDummyItem;
